import { Directive, TemplateRef, inject } from '@angular/core'

interface Context<T extends object> {
	$implicit: T
}

@Directive({ selector: '[appTableExpandableContentTemplate]' })
export class TableExpandableContentTemplateDirective<T extends object> {
	readonly templateRef = inject<TemplateRef<T>>(TemplateRef)

	static ngTemplateContextGuard<T extends object>(
		dir: TableExpandableContentTemplateDirective<T>,
		ctx: unknown,
	): ctx is Context<T> {
		return true
	}
}
